// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonPrimaryToggle = 2;
var ButtonPrimaryToggleOff = 1;
var ButtonSecondaryToggle = 2;
var ButtonSecondaryToggleOff = 1;
var ButtonTertiaryToggle = 2;
var ButtonTertiaryToggleOff = 1;
var ButtonPrimaryToggleGroupOn = 2;
var ButtonPrimaryToggleGroupOff = 1;
var ButtonSecondaryToggleGroupOn = 2;
var ButtonSecondaryToggleGroupOff = 1;
var ButtonTertiaryToggleGroupOn = 2;
var ButtonTertiaryToggleGroupOff = 1;
var PaginationNumbered = 2;
var BorderWidthSemanticsAll = {
  ButtonPrimaryToggle: ButtonPrimaryToggle,
  ButtonPrimaryToggleGroupOff: ButtonPrimaryToggleGroupOff,
  ButtonPrimaryToggleGroupOn: ButtonPrimaryToggleGroupOn,
  ButtonPrimaryToggleOff: ButtonPrimaryToggleOff,
  ButtonSecondaryToggle: ButtonSecondaryToggle,
  ButtonSecondaryToggleGroupOff: ButtonSecondaryToggleGroupOff,
  ButtonSecondaryToggleGroupOn: ButtonSecondaryToggleGroupOn,
  ButtonSecondaryToggleOff: ButtonSecondaryToggleOff,
  ButtonTertiaryToggle: ButtonTertiaryToggle,
  ButtonTertiaryToggleGroupOff: ButtonTertiaryToggleGroupOff,
  ButtonTertiaryToggleGroupOn: ButtonTertiaryToggleGroupOn,
  ButtonTertiaryToggleOff: ButtonTertiaryToggleOff,
  PaginationNumbered: PaginationNumbered
};

export { BorderWidthSemanticsAll, ButtonPrimaryToggle, ButtonPrimaryToggleGroupOff, ButtonPrimaryToggleGroupOn, ButtonPrimaryToggleOff, ButtonSecondaryToggle, ButtonSecondaryToggleGroupOff, ButtonSecondaryToggleGroupOn, ButtonSecondaryToggleOff, ButtonTertiaryToggle, ButtonTertiaryToggleGroupOff, ButtonTertiaryToggleGroupOn, ButtonTertiaryToggleOff, PaginationNumbered, BorderWidthSemanticsAll as default };
